<div [ngClass]="{'text-right': isRightAligned }">
    @if (params.isCheckbox && params.isCheckAllAllowed) {
        <div class="eod-checkbox eod-checkbox--md form-check justify-content-center m-0" style="min-width: 24px;" id="{{fieldKey}}">
        <!-- [(ngModel)]="params.isAllChecked" -->
            <input class="form-check-input is-primary" name="chkBxAll" (change)="onCheckboxChange($event)" type="checkbox"
                id="chkAll" placement="right" [ngbPopover]="popContent" container="body" triggers="mouseenter:mouseleave"
                [checked]="params.isAllChecked"
                [ngClass]="{'disabled': isGridEmpty }">
        </div>
    }
    @if (!params.isCheckbox) {
    <div class="ag-grid__header" id="{{fieldKey}}"
        [ngClass]="{'text-link':ascSort == 'active' ||  descSort == 'active'}"
        [ngClass]="{'text-primary': noSort === 'active', 'text-link': noSort !== 'active'}">
        @if (params.enableMenu) {
            <div #menuButton class="customHeaderMenuButton" (click)="onMenuClicked($event)">
                <i class="fa fa-bars"></i>
            </div>
        }
        <span class="header-text" (click)="onSortRequested($event)" [innerHTML]="sanitizerHtml(params.displayName)"> </span>
        @if (params.enableSorting || ascSort === 'active' || descSort === 'active') {
            <div (click)="onSortRequested($event)" [ngClass]="sortIconClass">
                @if (ascSort === 'active') {
                    <i class="fa fa-long-arrow-alt-up"></i>
                }
                @if (descSort === 'active') {
                    <i class="fa fa-long-arrow-alt-down"></i>
                }
            </div>
        }

        @if (headerTooltipIcon) {
            <div [placement]="headerTooltipPosition" [ngbPopover]="headerpopContent"
                container="body" triggers="mouseenter:mouseleave">
                <i [ngClass]="headerTooltipIcon"></i>
            </div>
        }
        @if (headerEditIcon) {
            <div>
                <i [ngClass]="headerEditIcon" (click)="handleHeaderClick($event)"></i>
            </div>
        }
    </div>
    }
</div>

<ng-template #popContent>
    <div [innerHTML]="sanitizerHtml(tooltipText)"></div>
</ng-template>

<ng-template #headerpopContent>
    <div [innerHTML]="sanitizerHtml(headerTooltip)"></div>
</ng-template>